import { MediaMatcher } from '@angular/cdk/layout';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { WebsiteAuditService } from '../website-audit.service';
import { Subscription } from 'rxjs';
import { DarkmodeService } from 'src/app/services/darkmode.service';

@Component({
  selector: 'app-sharable-component',
  templateUrl: './sharable-component.component.html',
  styleUrls: [
    '../../sidenav/sidenav.component.css',
    './sharable-component.component.css',
  ],
})
export class SharableWebsiteAuditComponent {
  constructor(
    private websiteAuditService: WebsiteAuditService,
    private route: ActivatedRoute,
    public media: MediaMatcher,
    private darkmodeService: DarkmodeService,
  ) {
    this.mobileQuery = media.matchMedia('(max-width: 1200px)');
  }

  public firstLoad: boolean = true;

  private subs: Subscription = new Subscription();

  public mobileQuery: MediaQueryList;

  public navigationLinksFiltered: any[] = [
    // {
    //   title: 'Dashboard',
    //   icon: {
    //     src: '../../assets/img/dashboard_icon.svg',
    //     inlineStyle: 'width:22px;height:22px;position:relative;left:-2px',
    //   },
    //   active: false,
    // },
    {
      title: 'Website Audit',
      icon: {
        src: '../../assets/img/website_analysis_icon.svg',
        inlineStyle: 'width:20px;height:16px',
      },
      active: true,
    },
    // {
    //   title: 'Nudge',
    //   icon: {
    //     src: '../../assets/img/nudge_icon.svg',
    //     inlineStyle: 'width:18px;height:18px',
    //   },
    //   active: false,
    // },
    // {
    //   title: 'NudgeGPT',
    //   icon: {
    //     src: '../../assets/img/genAI_nudge_icon.svg',
    //     inlineStyle: 'width:18px;height:18px',
    //   },
    //   active: false,
    // },
    // {
    //   title: 'Diagnostic',
    //   icon: {
    //     src: '../../assets/img/diagnostic_icon.svg',
    //     inlineStyle: 'width:18px;height:18px',
    //   },
    //   active: false,
    // },
    // {
    //   title: 'User Insights',
    //   icon: {
    //     src: '../../assets/img/recorder_icon.svg',
    //     inlineStyle: 'width:20px;height:20px',
    //   },
    //   active: false,
    // },
    // {
    //   title: 'Organic',
    //   icon: {
    //     src: '../../assets/img/organic_icon.svg',
    //     inlineStyle: 'width:19px;height:19px',
    //   },
    //   active: false,
    // },
    // {
    //   title: 'Merchandise',
    //   icon: {
    //     src: '../../assets/img/merchandising_icon.svg',
    //     inlineStyle: 'width:16px;height:16px;margin-left:2px',
    //   },
    //   active: false,
    // },
    // {
    //   title: 'Agents',
    //   icon: {
    //     src: '../../assets/img/automations_icon_1.svg',
    //     inlineStyle: 'width:20px;height:16px',
    //   },
    //   active: false,
    // },
    // {
    //   title: 'Signals',
    //   icon: {
    //     src: '../../assets/img/signals_icon.svg',
    //     inlineStyle: 'width:20px;height:16px',
    //   },
    //   active: false,
    // },
    // {
    //   title: 'Purchase Insights',
    //   icon: {
    //     src: '../../assets/img/purchase_insights-v2.svg',
    //     inlineStyle: 'width:21px;height:18px',
    //   },
    //   active: false,
    // },
    // {
    //   title: 'Ad Copilot',
    //   icon: {
    //     src: '../../assets/img/ad_copilot_icon.svg',
    //     inlineStyle: 'width:20px;height:16px',
    //   },
    //   active: false,
    // },
  ];

  public token: string;

  public selectedTask: any;

  private hubspotName: string = 'patrick-fischer1';

  ngOnInit(): void {
    this.token = this.route.snapshot.paramMap.get('token') as string;
    sessionStorage.setItem('shareableToken', this.token);

    const params = new URLSearchParams(location.search);
    this.hubspotName = params.get('hubspot')!;

    // Follow the theme the audit was shared with (falls back to light for older
    // links without the param). Set the body class so the --wa-* CSS variables
    // switch, and push the value through the darkmode service (without
    // persisting) so every audit component's charts/colors follow it too.
    const isDark = params.get('theme') === 'dark';
    if (isDark) {
      document.body.classList.add('dark-theme');
    } else {
      document.body.classList.remove('dark-theme');
    }
    this.darkmodeService.setDarkModeTransient(isDark);

    this.subs.add(
      this.websiteAuditService.getSelectedAuditTask().subscribe((res: any) => {
        if (res) {
          this.firstLoad = false;
          this.selectedTask = res || {};
        }
      }),
    );
  }

  ngOnDestroy(): void {
    sessionStorage.removeItem('shareableToken');
    // Undo the theme class this page set, so it doesn't leak to other views.
    document.body.classList.remove('dark-theme');
    this.subs.unsubscribe();
  }

  getDomainFromUrl(url: string): string | null {
    try {
      const normalized = url.startsWith('http') ? url : `https://${url}`;

      const { hostname } = new URL(normalized);
      return hostname.replace(/^www\./, '');
    } catch {
      return null;
    }
  }

  public openHubspot(): void {
    const url = `https://meetings.hubspot.com/${this.hubspotName || 'patrick-fischer1'}`;
    window.open(url, '_blank');
  }
}
